import React from 'react';
import {
  Container,
  Typography,
  Box,
  Grid,
  Card,
  CardContent,
  Paper,
  Avatar,
  Breadcrumbs,
  Link as MuiLink,
  Fade,
  Slide,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Alert,
  Stepper,
  Step,
  StepLabel,
  StepContent
} from '@mui/material';
import {
  NavigateNext as NavigateNextIcon,
  AssignmentReturn as AssignmentReturnIcon,
  Schedule as ScheduleIcon,
  MonetizationOn as MonetizationOnIcon,
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
  Warning as WarningIcon,
  Info as InfoIcon,
  ExpandMore as ExpandMoreIcon,
  Undo as UndoIcon,
  CreditCard as CreditCardIcon,
  LocalShipping as LocalShippingIcon,
  VerifiedUser as VerifiedUserIcon,
  ContactSupport as ContactSupportIcon,
  ThumbDown as ThumbDownIcon
} from '@mui/icons-material';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const ReturnPolicy = () => {
  const returnTypes = [
    {
      icon: <UndoIcon />,
      title: 'সাধারণ রিটার্ন',
      description: 'পণ্য পছন্দ না হলে বা সাইজ না মিললে',
      timeLimit: '৭ দিন',
      condition: 'অব্যবহৃত অবস্থায়',
      color: '#4CAF50'
    },
    {
      icon: <ThumbDownIcon />,
      title: 'ত্রুটিপূর্ণ পণ্য',
      description: 'পণ্যে কোনো ত্রুটি বা ক্ষতি থাকলে',
      timeLimit: '১৫ দিন',
      condition: 'ছবি ও প্রমাণসহ',
      color: '#FF9800'
    },
    {
      icon: <CancelIcon />,
      title: 'ভুল পণ্য',
      description: 'অর্ডারের চেয়ে ভিন্ন পণ্য পেলে',
      timeLimit: '৩ দিন',
      condition: 'তাৎক্ষণিক রিপোর্ট',
      color: '#F44336'
    },
    {
      icon: <CreditCardIcon />,
      title: 'রিফান্ড প্রক্রিয়া',
      description: 'টাকা ফেরত পাওয়ার নিয়ম',
      timeLimit: '৭-১৪ দিন',
      condition: 'যাচাইয়ের পর',
      color: '#2196F3'
    }
  ];

  const returnableItems = [
    {
      category: 'ফ্যাশন ও পোশাক',
      items: ['জামা-কাপড়', 'জুতা', 'ব্যাগ', 'অ্যাক্সেসরিজ'],
      timeLimit: '৭ দিন',
      condition: 'ট্যাগসহ অব্যবহৃত',
      returnRate: '৯৫%'
    },
    {
      category: 'ইলেকট্রনিক্স',
      items: ['মোবাইল', 'ল্যাপটপ', 'ক্যামেরা', 'হেডফোন'],
      timeLimit: '১৫ দিন',
      condition: 'বক্স ও ওয়ারেন্টিসহ',
      returnRate: '৮৫%'
    },
    {
      category: 'বই ও স্টেশনারি',
      items: ['বই', 'খাতা', 'কলম', 'শিক্ষা উপকরণ'],
      timeLimit: '৩ দিন',
      condition: 'অক্ষত অবস্থায়',
      returnRate: '৯০%'
    },
    {
      category: 'ঘর সাজানোর জিনিস',
      items: ['আসবাব', 'সাজসজ্জার জিনিস', 'বাসনপত্র'],
      timeLimit: '১০ দিন',
      condition: 'প্যাকেজিংসহ',
      returnRate: '৮০%'
    }
  ];

  const nonReturnableItems = [
    'খাদ্যপণ্য ও পানীয়',
    'ব্যক্তিগত স্বাস্থ্য পণ্য',
    'কসমেটিক্স (খোলা)',
    'অন্তর্বাস',
    'কাস্টমাইজড পণ্য',
    'ডিজিটাল পণ্য',
    'গাছপালা ও বীজ',
    'পচনশীল পণ্য'
  ];

  const returnSteps = [
    {
      title: 'রিটার্ন অনুরোধ',
      description: 'আমাদের কাস্টমার সার্ভিসে যোগাযোগ করুন বা অ্যাপে রিটার্ন রিকোয়েস্ট করুন'
    },
    {
      title: 'অনুমোদন',
      description: 'আমাদের টিম আপনার অনুরোধ পর্যালোচনা করে অনুমোদন দেবে'
    },
    {
      title: 'পণ্য প্যাকেজিং',
      description: 'পণ্যটি সঠিকভাবে প্যাকেজিং করুন এবং পিকআপের জন্য প্রস্তুত রাখুন'
    },
    {
      title: 'পিকআপ',
      description: 'আমাদের ডেলিভারি পার্টনার আপনার ঠিকানা থেকে পণ্য সংগ্রহ করবে'
    },
    {
      title: 'যাচাইকরণ',
      description: 'পণ্য আমাদের কাছে পৌঁছানোর পর আমরা এর অবস্থা যাচাই করব'
    },
    {
      title: 'রিফান্ড',
      description: 'যাচাইয়ের পর আপনার টাকা ফেরত দেওয়া হবে'
    }
  ];

  const refundMethods = [
    {
      method: 'মোবাইল ব্যাংকিং',
      time: '২-৩ দিন',
      fee: 'বিনামূল্যে',
      icon: <MonetizationOnIcon sx={{ color: '#4CAF50' }} />
    },
    {
      method: 'ব্যাংক ট্রান্সফার',
      time: '৫-৭ দিন',
      fee: 'বিনামূল্যে',
      icon: <CreditCardIcon sx={{ color: '#2196F3' }} />
    },
    {
      method: 'ক্যাশ অন ডেলিভারি রিফান্ড',
      time: '৭-১০ দিন',
      fee: '২০ টাকা',
      icon: <LocalShippingIcon sx={{ color: '#FF9800' }} />
    },
    {
      method: 'স্টোর ক্রেডিট',
      time: 'তাৎক্ষণিক',
      fee: 'বিনামূল্যে + ৫% বোনাস',
      icon: <VerifiedUserIcon sx={{ color: '#9C27B0' }} />
    }
  ];

  return (
    <>
      <Header />
      <Box sx={{ bgcolor: '#f8fafc', minHeight: '100vh' }}>
        {/* Hero Section */}
        <Box
          sx={{
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: 'white',
            py: 8,
            position: 'relative',
            overflow: 'hidden'
          }}
        >
          <Container>
            <Breadcrumbs 
              separator={<NavigateNextIcon fontSize="small" />} 
              aria-label="breadcrumb"
              sx={{ mb: 4, '& .MuiBreadcrumbs-separator': { color: 'rgba(255,255,255,0.7)' } }}
            >
              <MuiLink component={Link} to="/" sx={{ color: 'rgba(255,255,255,0.8)' }}>
                হোম
              </MuiLink>
              <Typography sx={{ color: 'white' }}>রিটার্ন পলিসি</Typography>
            </Breadcrumbs>

            <Fade in timeout={1000}>
              <Box sx={{ textAlign: 'center', mb: 6 }}>
                <Typography variant="h2" component="h1" gutterBottom sx={{ fontWeight: 700, mb: 2 }}>
                  রিটার্ন ও রিফান্ড পলিসি
                </Typography>
                <Typography variant="h5" sx={{ opacity: 0.9, maxWidth: '800px', mx: 'auto' }}>
                  আপনার সন্তুষ্টিই আমাদের অগ্রাধিকার - সহজ রিটার্ন ও দ্রুত রিফান্ড নীতি
                </Typography>
              </Box>
            </Fade>
          </Container>
        </Box>

        <Container sx={{ py: 6 }}>
          {/* Return Types */}
          <Box sx={{ mb: 8, pt: '80px' }}>
            <Typography variant="h3" component="h2" gutterBottom sx={{ fontWeight: 600, textAlign: 'center', mb: 6 }}>
              রিটার্নের ধরন
            </Typography>
            <Grid container spacing={2.5} sx={{ px: 2 }}>
              {returnTypes.map((type, index) => (
                <Grid item xs={12} sm={6} md={3} key={index} sx={{ mb: 2 }}>
                  <Slide direction="up" in timeout={800 + index * 200}>
                    <Card
                      sx={{
                        textAlign: 'center',
                        p: 3,
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        transition: 'all 0.3s ease',
                        '&:hover': {
                          transform: 'translateY(-4px)',
                          boxShadow: '0 8px 24px rgba(0,0,0,0.12)'
                        },
                        border: '1px solid #e2e8f0',
                        borderRadius: 2,
                        mx: 1,
                        mt: 1
                      }}
                    >
                      <Avatar
                        sx={{
                          bgcolor: type.color,
                          width: 64,
                          height: 64,
                          mx: 'auto',
                          mb: 2
                        }}
                      >
                        {type.icon}
                      </Avatar>
                      <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mb: 1.5 }}>
                        {type.title}
                      </Typography>
                      <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.6, mb: 2, flexGrow: 1 }}>
                        {type.description}
                      </Typography>
                      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mt: 'auto' }}>
                        <Chip 
                          label={type.timeLimit} 
                          color="primary" 
                          sx={{ fontWeight: 600 }}
                        />
                        <Chip 
                          label={type.condition} 
                          variant="outlined"
                          size="small"
                        />
                      </Box>
                    </Card>
                  </Slide>
                </Grid>
              ))}
            </Grid>
          </Box>

          {/* Returnable Items Table */}
          <Box sx={{ mb: 8, pt: '80px' }}>
            <Typography variant="h3" component="h2" gutterBottom sx={{ fontWeight: 600, textAlign: 'center', mb: 6 }}>
              রিটার্নযোগ্য পণ্যের তালিকা
            </Typography>
            <TableContainer component={Paper} sx={{ border: '1px solid #e2e8f0' }}>
              <Table>
                <TableHead>
                  <TableRow sx={{ bgcolor: '#f8fafc' }}>
                    <TableCell sx={{ fontWeight: 600, fontSize: '1.1rem' }}>পণ্যের ধরন</TableCell>
                    <TableCell sx={{ fontWeight: 600, fontSize: '1.1rem' }}>উদাহরণ</TableCell>
                    <TableCell sx={{ fontWeight: 600, fontSize: '1.1rem' }}>সময়সীমা</TableCell>
                    <TableCell sx={{ fontWeight: 600, fontSize: '1.1rem' }}>শর্ত</TableCell>
                    <TableCell sx={{ fontWeight: 600, fontSize: '1.1rem' }}>সফলতার হার</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {returnableItems.map((item, index) => (
                    <TableRow key={index} sx={{ '&:hover': { bgcolor: '#f8fafc' } }}>
                      <TableCell sx={{ fontWeight: 500 }}>{item.category}</TableCell>
                      <TableCell sx={{ fontSize: '0.9rem' }}>
                        {item.items.join(', ')}
                      </TableCell>
                      <TableCell sx={{ color: '#667eea', fontWeight: 600 }}>{item.timeLimit}</TableCell>
                      <TableCell sx={{ fontSize: '0.9rem' }}>{item.condition}</TableCell>
                      <TableCell>
                        <Chip 
                          label={item.returnRate}
                          color="success"
                          size="small"
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>

          {/* Non-Returnable Items */}
          <Box sx={{ mb: 8, pt: '80px' }}>
            <Typography variant="h3" component="h2" gutterBottom sx={{ fontWeight: 600, textAlign: 'center', mb: 6 }}>
              রিটার্ন অযোগ্য পণ্যসমূহ
            </Typography>
            <Paper sx={{ p: 4, border: '1px solid #e2e8f0' }}>
              <Alert severity="warning" sx={{ mb: 3 }}>
                <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
                  নিম্নলিখিত পণ্যসমূহ রিটার্ন করা যাবে না:
                </Typography>
              </Alert>
              <Grid container spacing={2}>
                {nonReturnableItems.map((item, index) => (
                  <Grid item xs={12} sm={6} md={3} key={index}>
                    <Chip
                      label={item}
                      variant="outlined"
                      color="error"
                      sx={{ 
                        width: '100%', 
                        height: 'auto',
                        py: 1,
                        '& .MuiChip-label': {
                          whiteSpace: 'normal',
                          textAlign: 'center'
                        }
                      }}
                    />
                  </Grid>
                ))}
              </Grid>
            </Paper>
          </Box>

          {/* Return Process Steps */}
          <Box sx={{ mb: 8, pt: '80px' }}>
            <Typography variant="h3" component="h2" gutterBottom sx={{ fontWeight: 600, textAlign: 'center', mb: 6 }}>
              রিটার্ন প্রক্রিয়া
            </Typography>
            <Paper sx={{ p: 4, border: '1px solid #e2e8f0' }}>
              <Stepper orientation="vertical">
                {returnSteps.map((step, index) => (
                  <Step key={index} active={true}>
                    <StepLabel>
                      <Typography variant="h6" sx={{ fontWeight: 600 }}>
                        {step.title}
                      </Typography>
                    </StepLabel>
                    <StepContent>
                      <Typography variant="body1" sx={{ lineHeight: 1.7, pb: 2 }}>
                        {step.description}
                      </Typography>
                    </StepContent>
                  </Step>
                ))}
              </Stepper>
            </Paper>
          </Box>

          {/* Refund Methods */}
          <Box sx={{ mb: 8, pt: '80px' }}>
            <Typography variant="h3" component="h2" gutterBottom sx={{ fontWeight: 600, textAlign: 'center', mb: 6 }}>
              রিফান্ডের পদ্ধতি
            </Typography>
            <Grid container spacing={4}>
              {refundMethods.map((method, index) => (
                <Grid item xs={12} sm={6} md={3} key={index}>
                  <Fade in timeout={1200 + index * 200}>
                    <Card
                      sx={{
                        textAlign: 'center',
                        p: 3,
                        height: '100%',
                        border: '1px solid #e2e8f0',
                        transition: 'all 0.3s ease',
                        '&:hover': {
                          transform: 'translateY(-2px)',
                          boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
                        }
                      }}
                    >
                      <Box sx={{ mb: 2 }}>
                        {method.icon}
                      </Box>
                      <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
                        {method.method}
                      </Typography>
                      <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                        সময়: {method.time}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        ফি: {method.fee}
                      </Typography>
                    </Card>
                  </Fade>
                </Grid>
              ))}
            </Grid>
          </Box>

          {/* Important Information */}
          <Box sx={{ mb: 8, pt: '80px' }}>
            <Typography variant="h3" component="h2" gutterBottom sx={{ fontWeight: 600, textAlign: 'center', mb: 6 }}>
              গুরুত্বপূর্ণ তথ্য
            </Typography>
            <Grid container spacing={4}>
              <Grid item xs={12} md={6}>
                <Alert severity="info" sx={{ mb: 3 }}>
                  <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
                    রিটার্ন শর্তাবলী
                  </Typography>
                  <Typography variant="body2">
                    পণ্য অবশ্যই মূল প্যাকেজিং, ট্যাগ ও রসিদসহ রিটার্ন করতে হবে। 
                    ব্যবহৃত বা ক্ষতিগ্রস্ত পণ্য রিটার্ন গ্রহণযোগ্য নয়।
                  </Typography>
                </Alert>
              </Grid>
              <Grid item xs={12} md={6}>
                <Alert severity="success" sx={{ mb: 3 }}>
                  <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
                    দ্রুত রিফান্ড
                  </Typography>
                  <Typography variant="body2">
                    আমরা ২৪ ঘন্টার মধ্যে রিটার্ন অনুরোধ প্রক্রিয়া করি এবং 
                    যাচাইয়ের পর দ্রুততম সময়ে রিফান্ড প্রদান করি।
                  </Typography>
                </Alert>
              </Grid>
            </Grid>
          </Box>

          {/* Detailed Terms */}
          <Box sx={{ mb: 8, pt: '80px' }}>
            <Typography variant="h3" component="h2" gutterBottom sx={{ fontWeight: 600, textAlign: 'center', mb: 6 }}>
              বিস্তারিত শর্তাবলী
            </Typography>
            <Paper sx={{ p: 4, border: '1px solid #e2e8f0' }}>
              <Accordion defaultExpanded>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    রিটার্ন যোগ্যতার শর্ত
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
                    পণ্য রিটার্ন করার জন্য অবশ্যই নির্ধারিত সময়সীমার মধ্যে অনুরোধ করতে হবে। 
                    পণ্যটি অব্যবহৃত, অক্ষত এবং মূল প্যাকেজিংয়ে থাকতে হবে।
                  </Typography>
                  <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
                    রিটার্নের কারণ উল্লেখ করতে হবে এবং প্রয়োজনে ছবি বা ভিডিও প্রমাণ দিতে হবে।
                  </Typography>
                </AccordionDetails>
              </Accordion>

              <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    রিফান্ড প্রক্রিয়া ও সময়সীমা
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
                    পণ্য আমাদের কাছে পৌঁছানোর পর ২৪-৪৮ ঘন্টার মধ্যে যাচাই করা হয়। 
                    যাচাই সম্পন্ন হলে রিফান্ড প্রক্রিয়া শুরু হয়।
                  </Typography>
                  <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                    রিফান্ডের পদ্ধতি অনুযায়ী ২-১০ কার্যদিবসের মধ্যে টাকা ফেরত পাবেন।
                  </Typography>
                </AccordionDetails>
              </Accordion>

              <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    বিশেষ পরিস্থিতি ও ব্যতিক্রম
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
                    ত্রুটিপূর্ণ বা ভুল পণ্যের ক্ষেত্রে রিটার্ন শিপিং খরচ আমরা বহন করব। 
                    অন্যান্য ক্ষেত্রে গ্রাহককে রিটার্ন শিপিং খরচ দিতে হবে।
                  </Typography>
                  <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                    বিশেষ ছাড়ে কেনা পণ্যের ক্ষেত্রে ভিন্ন রিটার্ন নীতি প্রযোজ্য হতে পারে।
                  </Typography>
                </AccordionDetails>
              </Accordion>
            </Paper>
          </Box>

          {/* Contact for Returns */}
          <Paper
            sx={{
              p: 6,
              textAlign: 'center',
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              color: 'white',
              borderRadius: 3,
              mt: '80px'
            }}
          >
            <ContactSupportIcon sx={{ fontSize: 64, mb: 2, opacity: 0.9 }} />
            <Typography variant="h4" gutterBottom sx={{ fontWeight: 600 }}>
              রিটার্ন সংক্রান্ত সহায়তা
            </Typography>
            <Typography variant="h6" sx={{ mb: 4, opacity: 0.9, maxWidth: '600px', mx: 'auto' }}>
              রিটার্ন বা রিফান্ড নিয়ে কোনো প্রশ্ন থাকলে আমাদের কাস্টমার সার্ভিস টিমের সাথে যোগাযোগ করুন
            </Typography>
            <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
              <MuiLink
                component={Link}
                to="/contact"
                sx={{
                  bgcolor: 'white',
                  color: 'primary.main',
                  px: 4,
                  py: 1.5,
                  borderRadius: 2,
                  textDecoration: 'none',
                  fontWeight: 600,
                  '&:hover': {
                    bgcolor: 'grey.100'
                  }
                }}
              >
                যোগাযোগ করুন
              </MuiLink>
              <MuiLink
                component={Link}
                to="/help"
                sx={{
                  border: '2px solid white',
                  color: 'white',
                  px: 4,
                  py: 1.5,
                  borderRadius: 2,
                  textDecoration: 'none',
                  fontWeight: 600,
                  '&:hover': {
                    bgcolor: 'rgba(255,255,255,0.1)'
                  }
                }}
              >
                সাহায্য কেন্দ্র
              </MuiLink>
            </Box>
          </Paper>
        </Container>
      </Box>
      <Footer />
    </>
  );
};

export default ReturnPolicy; 